<template>
    <div>
        <div class="Panel">
            <div class="Panel__heading">Data Import</div>
            <div class="Panel__body">
                <div class="row">
                    <div class="col-md-3">
                        <input type="file" id="file">

                        <div class="Form__error"
                             v-if="fileError"
                        >
                            {{ fileError }}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <button type="button"
                                class="Button mt-4"
                                @click.prevent="uploadFile"
                        >
                            Upload
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="Panel">
            <div class="Panel__heading">Label Editor</div>
            <div class="Panel__body">
                <label class="Form__label">
                    VIN
                </label>

                <input type="text"
                       class="Form__text"
                       placeholder="Search for a VIN"
                       v-model.trim="search"
                       @keyup.enter="findVin"
                >

                <div style="border-top: 1px solid #e2e6ef; margin-top: 20px; padding-top: 10px;"
                     v-if="vin !== null"
                >
                    <div v-if="vin">
                        <h2>{{ vin.vin }} - {{ vin.wltp_make.name }} {{ vin.wltp_model.name }}</h2>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Code
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_code"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Engine CC
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.engine_cc"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Gearbox Type Code
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.gearbox_type_code"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    CO2 Combined
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.co2_combined"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Weighted Combined CO2
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.weighted_combined_co2"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    WLTP Combined CO2
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.wltp_combined_co2"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    WLTP Weighted Combined CO2
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.wltp_weighted_combined_co2"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Consumption Low
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_consumption_low"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Consumption Medium
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_consumption_medium"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Consumption High
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_consumption_high"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Consumption Extra High
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_consumption_extra_high"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Consumption Combined
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_consumption_combined"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Fuel Consumption Weighted Combined
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.fuel_consumption_weighted_combined"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    CO
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.co"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    THC
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.thc"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    NMHC
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.nmhc"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    NOX
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.nox"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    Particulates
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.particulates"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Number of Particulates
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.number_of_particulates"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Ex Part
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.ex_part"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label for="hybrid_vehicle" class="Form__label">Hybrid Vehicle</label>
                                <div class="Form__select">
                                    <select name="hybrid_vehicle"
                                            id="hybrid_vehicle"
                                            v-model.trim="vin.hybrid_vehicle"
                                    >
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Electric Energy Consumption
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.electric_energy_consumption"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Electric Engery Range
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.electric_energy_range"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label for="pure_electric_vehicle" class="Form__label">Pure Electric Vehicle</label>
                                <div class="Form__select">
                                    <select name="pure_electric_vehicle"
                                            id="pure_electric_vehicle"
                                            v-model.trim="vin.pure_electric_vehicle"
                                    >
                                        <option value="0">No</option>
                                        <option value="1">Yes</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Electric Energy Cons Pure Electric
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.electric_energy_cons_pure_electric"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Electric Range
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.electric_range"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    WLTP Electric Range City Pure Elec
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.wltp_electric_range_city_pure_elec"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <label class="Form__label">
                                    Sound Level Stationary
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.sound_level_stationary"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Sound Level Stat Engine Speed
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.sound_level_stat_engine_speed"
                                >
                            </div>

                            <div class="col-md-3">
                                <label class="Form__label">
                                    Sound Level Drive By
                                </label>

                                <input type="text"
                                       class="Form__text"
                                       v-model.trim="vin.sound_level_drive_by"
                                >
                            </div>
                        </div>

                        <div class="row" style="margin-top: 25px; margin-bottom: 25px;">
                            <div class="col-md-3">
                                <button type="button"
                                        class="Button mt-4"
                                        @click.prevent="saveVin"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <h2>VIN Not Found</h2>
                    </div>

                </div>

                <div style="border-top: 1px solid #e2e6ef; margin-top: 20px; padding-top: 10px;"
                     v-if="success"
                >
                    <h2>VIN Successfully Updated</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                file: null,
                fileError: false,

                search: '',

                vin: null,

                success: false,
            }
        },

        methods: {
            uploadFile() {
                let formData = new FormData;

                formData.append('file', document.querySelector('#file').files[0]);

                axios.post('/system-settings/co2/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.search = response.data.vin;
                    this.vin = response.data;
                    this.fileError = false;
                }).catch(response => {
                    this.fileError = 'There is a problem with the file.'
                })
            },

            findVin() {
                axios.post('/system-settings/co2/search', { vin: this.search })
                    .then(response => {
                        this.vin = response.data;
                    })
                    .catch(response => {
                        this.vin = false;
                    })
            },

            saveVin() {
                axios.patch('/system-settings/co2/vin', this.vin)
                    .then(() => {
                        this.vin = null;
                        this.success = true;
                        this.search = '';

                        setTimeout(() => {
                            this.success = false;
                        }, 5000);
                    })
            }
        }
    }
</script>